export const segmentData = [
  { label: "All", value: "all" },
  { label: "Unread", value: "unread" },
  { label: "Favourite", value: "favourite" },
];
